// @ts-nocheck
import angular from 'angular';
import { environment } from "environments";

export class StaffUserController {
  /* @ngInject */
  constructor($log, $stateParams, $filter, toastr, Users, Business, Utils, Notifications) {
    Object.assign(this, {
      $log,
      $stateParams,
      $filter,
      toastr,
      Users,
      Business,
      Utils,
      Notifications,
      states: []
    });
    this.getAllStates();
    this.load();
    this.getAllRoles();
    this.environment = environment.constants.ENV;
    this.BOD_642= ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV)
    this.BOD_381_feature_flag = ['localhost', 'qa', 'dev', 'staging', 'production'].includes(this.environment)
    this.LMNUK_1800 = ['localhost', 'dev', 'qa', 'staging', 'production'].includes(this.environment)
    this.userTitles = ["Canon",
      "Captain",
      "Dame",
      "Dr",
      "Father",
      "Lady",
      "Lieutenant",
      "Lord",
      "Madam",
      "Major",
      "Master",
      "Miss",
      "Mr",
      "Mrs",
      "Ms",
      "Mx",
      "Professor",
      "Reverend",
      "Sergeant",
      "Sir",
      "Sister",
      "Unknown",]
  }

  getAllRoles() {
    this.userId = this.$stateParams.id
   this.Business.getAllRoles()
     .then(({ data }) => {
      this.roles = Object.values(data).map(role => ({
        name: role,
        checked: false
      }));
    });
  }


  getAllStates() {
    this.Business.getAllStates().then(({
      data
    }) => {
      this.states = data;
      var elem = {
        "id": 0,
        "code": "SELECT",
        "supported": 1,
        "slv": 1,
        "slv_enabled": 1,
        "state": "Select a state"
        };
      this.states.unshift(elem);
      this.selectedState = "SELECT";
      }).catch(err => {
        this.states = [];
        this.$log.error(err);
      });
  }
  updateUserRoles() {
    // the code below produces an array of strings representing the roles that have been checked;
    if (!this.notes) {
      this.notes = null;
      this.toastr.error(this.Notifications.generic.failure);
    } else {
      this.userCopy.roles = this.roles
        .filter(role => role.checked)
        .map(role => role.name);
      // eslint-disable-next-line max-len
      this.Users.updateStaffUser(this.$stateParams.id, { roles: this.userCopy.roles, note: this.notes })
        .then(() => {
          this.toastr.success(this.Notifications.users.updateSuccess);
          this.notes = "";
        })
        .catch((err) => {
          this.toastr.error(this.Notifications.generic.failure);
          this.$log.error(err);
        });
    }
  }
  update() {
    try {
      const payload = this.Utils.findDifference(this.user, this.userCopy);

      if (_.isEmpty(payload)) {
        return;
      }

      this.Users.updateStaffUser(this.$stateParams.id, payload).then(({
        data
        }) => {
        this.user = angular.copy(this.userCopy);
        this.toastr.success(this.Notifications.users.updateSuccess);
      }).catch(err => {
        this.toastr.error(this.Notifications.generic.failure);
        this.$log.error(err);
      });
    } catch (e) {
      this.toastr.error(this.Notifications.generic.failure);
      this.$log.error(err);
    }
  }

  load() {
    this.Users.getStaffUser(this.$stateParams.id)
      .then(({ data }) => {
        data.roles = Object.values(data.roles);
        this.user = data;
        Object.values(this.user.roles).forEach((myRole) => {
          this.roles.forEach((role) => {
            role.checked = (role.name === myRole) || (role.checked);
          });
        });
        this.userCopy = angular.copy(this.user);
      })
      .catch((err) => {
        this.user = null;
        this.$log.error(err);
      });
  }

  addLicense() {
    if (this.selectedState === "SELECT") {
      this.toastr.error('Please select a state');
      return;
    }

    if (!this.license_number) {
      this.toastr.error('Please enter a license number');
      return;
    }

    this.Users.addStaffUserState(this.$stateParams.id, this.selectedState, this.license_number).then(data => {
      this.toastr.success('License added successfully');
      this.load();
      }).catch(err => {
        this.toastr.error('Error adding license ' + err.status + ' - ' + err.message);
        this.$log.error(err);
      });
  }

  removeLicense(state_code) {
    this.Users.removeStaffUserState(this.$stateParams.id, state_code).then(data => {
      this.toastr.success('License removed successfully');
      this.load();
      }).catch(err => {
        this.toastr.error('Error removing license ' + err.status + ' - ' + err.message);
        this.$log.error(err);
      });
  }

}

StaffUserController.$inject = ["$log", "$stateParams", "$filter", "toastr", "Users", "Business", "Utils", "Notifications"];
angular.module('pims').controller('StaffUserController', StaffUserController);
